<template>
	<div class="home">
		<offerComponentVue />
	</div>
</template>

<script>
import offerComponentVue from "@/components/client/ordersComponent.vue";
export default {
	name: "HomeView",
	components: {
		offerComponentVue,
	},
};
</script>
